export class TopMenuData {
  public id: number
  public name: string
  public key: string
  public value: number
  public color: string
  constructor(
    id: number,
    name: string,
    key: string,
    value: number,
    color: string
  ) {
    this.id = id
    this.name = name
    this.key = key
    this.value = value
    this.color = color
  }
}

export class ChartData {
  public period: string
  public value: number
  constructor(period: string, value: number) {
    this.period = period
    this.value = value
  }
}
export class MonthlyAccessChartsData {
  public month: number
  public percentage: number
  public totalUserAccess: number
  public totalUserVisit: number
  constructor(
    month: number,
    percentage: number,
    totalUserAccess: number,
    totalUserVisit: number
  ) {
    this.month = month
    this.percentage = percentage
    this.totalUserAccess = totalUserAccess
    this.totalUserVisit = totalUserVisit
  }
}

export class TopVisitData {
  public id: number
  public title: string
  public total_user: string
  public total_visit: string
  public created_date: string
  public file_code: string
  constructor(
    id: number,
    file_code: string,
    title: string,
    created_date: string,
    total_user: string,
    total_visit: string
  ) {
    this.id = id
    this.file_code = file_code
    this.title = title
    this.created_date = created_date
    this.total_user = total_user
    this.total_visit = total_visit
  }
}

export class ExportData {
  public link: string
  constructor(link: string) {
    this.link = link
  }
}

export class Export {
  public success: boolean
  public message: string
  public data?: ExportData

  constructor(success: boolean, message: string, data?: ExportData) {
    this.success = success
    this.message = message
    this.data = data
  }
}

export class AdditionalInfoReport {
  public success: boolean
  public message: string
  public topMenu?: TopMenuData[]
  public chart?: ChartData[]
  public monthlyAccessCharts?: MonthlyAccessChartsData[]
  public topVisit?: TopVisitData[]
  constructor(
    success: boolean,
    message: string,
    topMenu?: TopMenuData[],
    chart?: ChartData[],
    monthlyAccessCharts?: MonthlyAccessChartsData[],
    topVisit?: TopVisitData[]
  ) {
    this.success = success
    this.message = message
    this.topMenu = topMenu
    this.chart = chart
    this.monthlyAccessCharts = monthlyAccessCharts
    this.topVisit = topVisit
  }
}
